import React, { useContext, useEffect, useState } from "react";
import validator from "validator";
import { useForm } from "../../../../../hooks/useForm";
import { AppContext } from "../../../Context/Context";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

export const NuevoUsuario2 = () => {
    const history = useHistory();
    const [state, setState] = useContext(AppContext);
    const [emails, setemails] = useState([]);
    const [emailReSend, setemailReSend] = useState(null);
    const [reSend, setreSend] = useState(false);
    const [tokenLogin, setTokenLogin] = useState("");
    const [cooldown, setCooldown] = useState(0);
    const [formValues, handleInputChange, reset] = useForm({
        email: ""
    });
    let documento = atob(sessionStorage.getItem("ctLocal"));

    useEffect(() => {
        const asyncFunction = async () => {
            const endpoint = await (await fetch('/api/show_endpoints/wsvalidakey')).json();

            fetch(
                `${endpoint.url_base}${endpoint.url_variable}?Key=7b7e11bebe768ede59c3ea9363a70c06`,
                {
                    cache: 'no-cache'
                }
            )
                .then(response => response.json())
                .then(async (json) => {
                    setState({ ...state, token: json });
                    const endpoint = await (await fetch('/api/show_endpoints/wsrecuperapassword')).json();

                    fetch(
                        `${endpoint.url_base}${endpoint.url_variable}?CUIT=${documento}&Token=${json.Token.Token}`,
                        {
                            cache: "no-cache",
                        }
                    )
                        .then(response => response.json())
                        .then(json => {
                            json.Mails.Mails.map(email => {
                                if (email.ErrorCodigo === "00") {
                                    setTokenLogin(email.TokenLogin);
                                    setemails(prevState => {
                                        return [...prevState, email.Mail];
                                    });
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Error",
                                        text: email.ErrorDescripcion
                                    });
                                    // history.push("/recuperar_contrasena");
                                    history.push("/nuevo_usuario");
                                    return;
                                }
                            });
                        });
                });
        }
        asyncFunction();
    }, []);

    let { email } = formValues;
    const [errorEmail, seterrorEmail] = useState(null);
    const [isValid, setisValid] = useState(false);

    const startCooldown = () => {
        setCooldown(60);
        const timerId = setInterval(() => {
            setCooldown(prevCooldown => {
                if (prevCooldown <= 1) {
                    clearInterval(timerId);
                    return 0;
                }
                return prevCooldown - 1;
            });
        }, 1000);
    };

    const auditService = async (modo, tipo_envio) => {
        try {
            if (modo != "SMS") {
                modo = "MAIL"
            }

            const auditoriaServicioData = {
                marca: "fiat",
                modo: modo,
                tipo_envio: tipo_envio,
                codigo_motivo: 1,
                motivo: "Crear contraseña",
                fecha_hora: new Date().toISOString(),
                cuit_cuil: documento,
            };

            let response = await fetch('/api/post_auditoria_servicio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(auditoriaServicioData)
            });

            response = await response.json();
            if (response.success) {
                return
            } else {
                // Handle error in response
            }
        } catch (err) {
            console.log("Error: ", err);
        }
    }

    function maskEmail(email) {
        const parts = email.split("@");

        if (parts.length !== 2) {
            return email;
        }

        const localPart = parts[0];
        const domain = parts[1];

        let maskedLocalPart = localPart.substr(0, 1);
        maskedLocalPart += "*".repeat(localPart.length - 2);
        maskedLocalPart += localPart.substr(-1);

        return `${maskedLocalPart}@${domain}`;
    }

    let optionsEmails = [];
    if (emails.length !== 0) {
        emails.forEach((email, index) => {
            const maskedEmail = maskEmail(email);
            optionsEmails.push(
                <option key={index} value={email}>
                    {maskedEmail}
                </option>
            );
        });
    }

    let checkValues = () => {
        if (!validator.isEmail(email)) {
            seterrorEmail("Seleccione un email");
        } else {
            setisValid(true);
            seterrorEmail("");
        }
    };
    useEffect(() => {
        if (isValid) {
            handleSubmit();
        }
    }, [isValid]);

    const handleReSendEmail = async () => {
        auditService("MAIL", "Reenvío");
        const endpoint = await (await fetch('/api/show_endpoints/wsvalidakey')).json();

        fetch(
            `${endpoint.url_base}${endpoint.url_variable}?Key=7b7e11bebe768ede59c3ea9363a70c06`,
            {
                cache: 'no-cache'
            }
        )
            .then(response => response.json())
            .then(async (json) => {
                setState({ ...state, token: json });
                const endpoint = await (await fetch('/api/show_endpoints/wsenviamail')).json();
                const envs = await (await fetch('/get_ambientes')).json();
                const activeEnv = envs.find((env) => env.activo);

                fetch(
                    `${endpoint.url_base}${endpoint.url_variable}?CUIT=${documento}&EMail=${emailReSend}&Link=https://www.${activeEnv.nombre === 'Test' ? 'non-prod.' : ''}fiatplan.com.ar/nuevo_usuario_contrasena_ingresa_clave?${encodeURIComponent(`CUIT=${documento}&TokenLogin=${tokenLogin}`)}`,
                    {
                        cache: "no-cache",
                    }
                )
                    .then(response => response.json())
                    .then(json => {
                        const maskedEmail = maskEmail(emailReSend);
                        console.log(emailReSend, documento, json);
                        if (json.Resultado.ErrorCodigo === "00") {
                            Swal.close();
                            reset();
                            setisValid(true);
                            setemailReSend(emailReSend);
                            setreSend(true);
                            Swal.fire({
                                icon: "success",
                                title: `EMail Enviado  a ${maskedEmail}`,
                                text:
                                    "A la brevedad recibirás un link para generar tu clave"
                            });
                        }

                        if (json.Resultado.ErrorCodigo === "01") {
                            Swal.close();
                            reset();
                            setisValid(false);
                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: " Reintente"
                            });
                            history.push("/login_mi_plan");
                        }

                        if (json.Resultado.ErrorCodigo === "02") {
                            Swal.close();
                            reset();
                            setisValid(false);
                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: `El Email ${email}, no esta cargado en el CUIT.`
                            });
                        }

                        if (json.Resultado.ErrorCodigo === "03") {
                            Swal.close();
                            reset();
                            setisValid(false);
                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text:
                                    "El documento ingresado no tiene mails asociados"
                            });
                        }
                        if (json.Resultado.ErrorCodigo === "04") {
                            Swal.close();
                            reset();
                            setisValid(false);
                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text:
                                    "El documento ingresado no corresponde a un cliente"
                            });
                        }
                    });
            });
    };

    let handleSubmit = async (e) => {
        if (e) {
            e.preventDefault();
        }

        checkValues();
        if (isValid) {
            auditService("MAIL", "Envío");
            startCooldown();
            Swal.fire({
                title: "Enviando datos",
                html: "cargando...",
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: false,
                customClass: {
                    loader: "colorSwal"
                },
                willOpen: () => {
                    Swal.showLoading();
                }
            });
            const endpoint = await (await fetch('/api/show_endpoints/wsvalidakey')).json();

            fetch(
                `${endpoint.url_base}${endpoint.url_variable}?Key=7b7e11bebe768ede59c3ea9363a70c06`,
                {
                    cache: 'no-cache'
                }
            )
                .then(response => response.json())
                .then(async (json) => {
                    setState({ ...state, token: json });
                    const endpoint = await (await fetch('/api/show_endpoints/wsenviamail')).json();
                    const envs = await (await fetch('/get_ambientes')).json();
                    const activeEnv = envs.find((env) => env.activo);

                    fetch(
                        `${endpoint.url_base}${endpoint.url_variable}?CUIT=${documento}&EMail=${email}&Link=https://www.${activeEnv.nombre === 'Test' ? 'non-prod.' : ''}fiatplan.com.ar/nuevo_usuario_contrasena_ingresa_clave?${encodeURIComponent(`CUIT=${documento}&TokenLogin=${tokenLogin}`)}`,
                        {
                            cache: "no-cache",
                        }
                    )
                        .then(response => response.json())
                        .then(json => {
                            const maskedEmail = maskEmail(email);
                            if (json.Resultado.ErrorCodigo === "00") {
                                Swal.close();
                                reset();
                                setisValid(true);
                                setemailReSend(email);
                                Swal.fire({
                                    icon: "success",
                                    title: `EMail Enviado a ${maskedEmail}`,
                                    text:
                                        "A la brevedad recibirás un link para generar tu clave"
                                });
                            }

                            if (json.Resultado.ErrorCodigo === "01") {
                                Swal.close();
                                reset();
                                setisValid(false);
                                Swal.fire({
                                    icon: "error",
                                    title: "Error",
                                    text: " Reintente"
                                });
                                history.push("/login_mi_plan");
                            }

                            if (json.Resultado.ErrorCodigo === "02") {
                                Swal.close();
                                reset();
                                setisValid(false);
                                Swal.fire({
                                    icon: "error",
                                    title: "Error",
                                    text: `El Email ${email}, no esta cargado en el CUIT.`
                                });
                            }

                            if (json.Resultado.ErrorCodigo === "03") {
                                Swal.close();
                                reset();
                                setisValid(false);
                                Swal.fire({
                                    icon: "error",
                                    title: "Error",
                                    text:
                                        "El documento ingresado no tiene mails asociados"
                                });
                            }
                            if (json.Resultado.ErrorCodigo === "04") {
                                Swal.close();
                                reset();
                                setisValid(false);
                                Swal.fire({
                                    icon: "error",
                                    title: "Error",
                                    text:
                                        "El documento ingresado no corresponde a un cliente"
                                });
                            }
                        });
                });
        }
    };

    return (
        <div className="login">
            <div className="login_title">
                <h1>CREAR NUEVO USUARIO</h1>
            </div>
            <div className="login_formDiv">
                <div className="login_formDiv--desktop">
                    <div className="login_formDiv--desktop--form">
                        <form className="login_form" onSubmit={handleSubmit}>
                            <h1>USUARIO NUEVO</h1>
                            <p className="title mb-base">
                                Ingrese su email para crear una contraseña.
                            </p>

                            <select
                                name="email"
                                value={email}
                                type="text"
                                onChange={handleInputChange}
                            >
                                <option value="">Elige un email</option>
                                {optionsEmails}
                            </select>
                            <p
                                className={`${errorEmail != null && errorEmail != ""
                                    ? "errorMsgInput"
                                    : ""
                                    } `}
                            >
                                {errorEmail}
                            </p>

                            <button
                                className="login_form--button mt-base"
                                type="submit"
                                disabled={cooldown > 0}
                            >Enviar
                            </button>
                            <div>
                                <p>{cooldown > 0 ? `Aguarde ${cooldown}s para reenviar` : ""}</p>
                            </div>
                            {isValid && (
                                <div
                                    className="login_links my-base"
                                    onClick={handleReSendEmail}
                                >
                                    <a style={{ cursor: "pointer" }}>
                                        No recibí el email.
                                    </a>
                                </div>
                            )}
                            {reSend && (
                                <div className="login_form--safe mb-base">
                                    <p>
                                        Volvimos a enviarte un mail para generar
                                        la contraseña.
                                    </p>
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
